<form [formGroup]="createQrisForm">
  <div class="d-flex flex-column p-4">
    <h6 class="text-bold">Create Payment - QRIS</h6>
    <hr />
    <div class="mt-3 table-responsive">
      <table class="table">
        <thead class="bg-light">
          <tr>
            <th>Name</th>
            <th style="min-width: 200px;">Input</th>
            <th style="min-width: 300px;">Expect Result</th>
            <th style="min-width: 200px;">cURL</th>
            <th style="min-width: 200px;">Result</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let items of uatPaymentMethod; let i = index">
            <td
              class="text-grey col-2"
              [innerHTML]="items.name || '-'"
            ></td>
            <td class="text-grey col-2 fst-italic w-[200px] min-w-[200px]">
              <pre class="mb-0 whitespace-pre-wrap bg-transparent p-0 border-0 text-[14px]" [innerHTML]="formatJson(items.input) || '-'"></pre>
            </td>
            <td class="text-grey fira-code w-[300px] min-w-[300px] break-words break-all">
              <pre class="mb-0 whitespace-pre-wrap bg-transparent p-0 border-0 text-[14px]" [innerHTML]="formatJson(items.expected_result) || '-'"></pre>
            </td>
            <td class="col-2">
              <textarea rows="8" nz-input [formControlName]="'curl_' + items.id" placeholder="-"></textarea>
            </td>
            <td class="col-2">
              <textarea rows="8" [formControlName]="'result_' + items.id" nz-input placeholder="-"></textarea>
            </td>
            <td class="col-2">{{ items.notes || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex align-self-end gap-2 py-3">
      <button class="btn btn-outline-secondary" (click)="previus()">Back</button>
      <button [disabled]="createQrisForm.invalid" [ngClass]="{
        'btn-primary': createQrisForm.valid,
        'btn-secondary': !createQrisForm.valid
      }" class="btn text-white" (click)="next()">Next</button>
    </div>
  </div>
</form>
<app-modal-confirm-back [isShowConfirm]="isConfirmBack" [docType]="'UAT'" (isShowConfirmEvent)="closeConfirmBack()"></app-modal-confirm-back>
